export const themeMap = new Map([
  ["sharebike", "sharebike"],
  ["lisa", "sharebike"],
  ["shematic", "shematic"],
  ["moby", "moby"],
  ["bigissue", "bigissue"],
  ["farte", "farte"],
  ["fartebysykkel", "farte"],
  ["sigo", "sigo"],
  ["sefa", "sefa"],
  ["weelz", "weelz"],
  ["gjovik", "gjovik"],
]);

export const resolveAppTheme = (code: string | null) =>
  themeMap.get(code?.toLowerCase() ?? "") ?? "sharebike";
